import {
  ContactsTemplate,
  MsgTemplate,
  TemplateButtons,
} from '../../schema/message/inferface';

export const getContactTemplate = (
  template: ContactsTemplate
): { template: MsgTemplate; buttons: TemplateButtons[] } => {
  const { contacts, type } = template;
  const contactBody = contacts.reduce((acc, { name, phones }) => {
    acc += `${name.first_name} : ${phones
      .map(({ phone }) => phone)
      .join(', ')}\n\n`;
    return acc;
  }, '');

  return {
    template: {
      [type]: {
        components: [
          {
            type: 'body',
            text: contactBody,
            format: 'TEXT',
          },
        ],
        params: [],
      },
    },
    buttons: [],
  };
};
